var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXtrafyls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1096,
    height: 238,
    viewBox: "0 0 1096 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6236_2358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.681 88.9728H293.558V188.348H243.879V88.9728H229.577L215.34 59.6343V49.849H243.879V0.169922H293.558V49.849H332.699V88.9901L332.681 88.9728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.736 109.313H472.704V95.0114C472.704 90.4951 471.198 88.9897 466.702 88.9897H412.572C407.971 88.9897 406.465 90.4951 406.465 95.0114V188.348H356.786V78.4517C356.786 58.8812 365.819 49.8486 385.389 49.8486H498.296C502.812 49.8486 504.318 51.3541 504.318 55.8703V95.0114L481.736 109.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.893 88.9897V49.8486H656.366C675.936 49.8486 684.969 58.8812 684.969 78.4517V182.301C684.969 186.332 682.978 188.348 679.249 188.348H563.029C537.437 188.348 528.405 179.315 528.405 153.723V135.658C528.405 111.571 537.437 102.579 563.029 102.579H635.273H635.29L635.273 99.5462C635.273 93.506 632.279 88.9897 625.504 88.9897H531.893ZM635.273 153.723L635.29 131.142H587.109C581.143 131.142 578.084 134.111 578.084 140.174V150.712C578.084 156.734 581.134 159.745 587.116 159.745H629.268C633.784 159.745 635.273 158.239 635.273 153.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.973 89.0517H785.832L785.763 188.348H736.084L736.153 89.0517H721.851L707.55 59.6343L707.55 49.849H736.153V28.773C736.153 9.20244 745.185 0.169922 764.756 0.169922H810.671L824.973 22.7513V31.7839H796.37C788.306 31.7839 785.924 35.6407 785.924 44.3299V49.849H824.973V89.0517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.483 131.142L966.483 49.8486H1016.16V185.995C1016.16 217.122 996.97 238.027 956.332 238.027L861.131 238.027L861.131 198.886H951.429C961.967 198.886 966.483 194.37 966.483 183.832V170.283H889.707C864.115 170.283 855.082 161.25 855.082 135.658L855.082 49.8646L904.761 49.8646V116.087C904.761 126.625 909.277 131.142 919.815 131.142H966.483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.27 188.348V0.169922H1095.95V188.348H1046.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4255 0.169922L118.85 59.5945H59.4255L29.7132 89.3068L0.000976562 59.5945L0.00112072 0.169922H59.4255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.754 188.348L69.3292 128.923H128.754L158.466 99.2107L188.178 128.923L188.178 188.348H128.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000114441 128.923L59.4244 69.4983V128.923L89.1367 158.635L59.4244 188.348H-0.000114441V128.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.178 59.5948L128.754 119.019V59.5946L99.0415 29.8822L128.754 0.169922H188.178V59.5948Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6236_2358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1096,
    height: 238,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtrafyls);
export default __webpack_public_path__ + "static/media/xtrafyls.1b3006bb37c15d597788eb3b3d609164.svg";
export { ForwardRef as ReactComponent };